/* eslint no-console: 0 */
// modules
import { from } from 'rxjs'
import { map, tap, ignoreElements, retryWhen } from 'rxjs/operators'
import { ofType } from 'redux-observable'
// actions
import { dataFrontendError } from '@weblite/action/errors'
// helper
import { send } from '../../setup/ws'
import { getClientUserId } from '$logic/client-user'

const errorHandler = (err$, actionType, stack) =>
  err$.pipe(
    map(error => (stack && error ? error : error.stack)),
    tap(e => console.log(`${actionType}: ${e}`)),
    tap(e =>
      send(
        dataFrontendError({
          actionType,
          message: e,
          userId: getClientUserId(),
        }),
        true,
        50,
      ),
    ),
  )

const createActionStream = (func$, action$, actionType, state$) =>
  func$(action$.pipe(ofType(actionType)), {
    state$,
    rawAction$: action$,
  }).pipe(ignoreElements())

export default (actionType, func$, { stack } = {}) => (action$, state$) =>
  from(createActionStream(func$, action$, actionType, state$)).pipe(
    retryWhen(err$ => errorHandler(err$, actionType, stack)),
  )
